import React from 'react';
import { Box } from '@chakra-ui/react';
import { useAppContext } from '../../../context/appContext';
import { E_INVOICE_FORM_ID } from '../constants/eInvoice';

const EInvoiceForm = () => {
  const { einvoiceCarrier } = useAppContext();
  const { enabled, data } = einvoiceCarrier;
  if (!enabled) {
    return null;
  }
  return (
    <Box
      as="form"
      hidden
      name="eInvoiceCarrierForm"
      id={E_INVOICE_FORM_ID}
      method="post"
      action="https://einvoice.lorealuxe.com/invcarrier.php"
      target="_blank"
    >
      <input type="hidden" id="method" name="method" value="einvoice" />
      <input type="hidden" id="em" name="em" value={data.email} />
      <input type="hidden" id="brd" name="brd" value={data.brand} />
      <input type="hidden" id="uuid" name="uuid" value={data.uid} />
      <input type="hidden" id="sg" name="sg" value={data.signature} />
      <button type="submit"></button>
    </Box>
  );
};

export default EInvoiceForm;
